<template>
  <div>
    <button
      v-tooltip="{content: $t('ct-card-site-edit'), class: 'ba-tooltip-custom'}"
      class="btn-circle"
      @click.prevent="openEditSite"
    >
      <font-awesome-icon
        :icon="['fas', 'pen']"
        class="font-awesome-icon"
      />
    </button>
    <button
      v-tooltip="{content: $t('ct-website-manager'), class: 'ba-tooltip-custom'}"
      class="btn-circle"
      @click.prevent="openSite"
    >
      <i class="ct-icon-website-manager" style="height: 20px;font-size: 20px;"/>
    </button>

    <button
      v-if="isUnpublish && website_type !== 'mirror'"
      v-tooltip="{content: $t('ct-publish'), class: 'ba-tooltip-custom'}"
      class="btn-circle ba-color-hover-white1"
      @click.prevent="publish"
    >
      <builderall-icon code='5183'></builderall-icon>
      <!-- <i class="ct-icon-new-publish" style="font-size: 12px;" /> -->
    </button>
    <button
      v-else
      v-tooltip="{content: $t('ct-card-eye'), class: 'ba-tooltip-custom'}"
      class="btn-circle"
      @click.prevent="goToWebsite(config)"
    >
      <font-awesome-icon
        :icon="['fas', 'eye']"
        class="font-awesome-icon"
      />
    </button>

    <div class="btn-group">
      <button
        v-tooltip="{content: $t('ct-card-site-settings'), class: 'ba-tooltip-custom'}"
        type="button"
        class="btn-circle dropdown-toggle"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      ><font-awesome-icon :icon="['fas', 'ellipsis-h']" class="font-awesome-icon"/></button>
      <div
        v-if="website_type === 'mirror'"
        class="dropdown-menu dropdown-menu-right"
      >
        <a
          href="#"
          class="dropdown-item"
          data-ba-i="update-cache-mirror"
          @click.prevent="updateCacheMirrorWebsite">
          <i class="svg-icon svgi-http svgi-dark "/>
          {{ $t('ct-update-cache') }}
        </a>
        <a
          href="#"
          class="dropdown-item"
          data-ba-i="delete-mirror"
          @click.prevent="deleteMirrorRecord">
          <i class="svg-icon svgi-http svgi-dark "/>
          {{ $t('ct-domain-desconnect') }}
        </a>
      </div>
      <div
        v-else
        class="dropdown-menu dropdown-menu-right"
      >
        <a
          href="#"
          class="dropdown-item"
          @click.prevent="goToSettings">
          <i class="ct-icon-settings"/>
          {{ $t('ct-settings') }}
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-ba-i="edit-share-img"
          @click.prevent="openSite">
          <i class="ct-icon-list-pages"/>
          {{ $t('ct-website-list-pages') }}
        </a>

        <button
          href="#"
          data-ba-i="publish-website"
          class="dropdown-item"
          @click.prevent="publish">
          <i class="ct-icon-new-publish"/>
          {{ $t('ct-publish') }}
        </button>

        <a
          v-if="config.status == 'active'"
          href="#"
          class="dropdown-item"
          data-ba-i="unpublish-website"
          @click.prevent="unpublish()">
          <i class="ct-icon-new-unpublish"/>
          {{ $t('ct-unpublish') }}
        </a>

        <a
          href="#"
          class="dropdown-item"
          data-ba-i="edit-share-img"
          @click.prevent="$emit('uploadImagePage', pageHome)">
          <i class="ct-icon-share-image"/>
          {{ $t('ct-image-share-edit') }}
        </a>

        <a
          v-if="config.dominio"
          href="#"
          class="dropdown-item"
          data-ba-i="disconnect-domain"
          @click.prevent="goToDomain()">
          <i class="ct-icon-dns"/>
          {{ $t('ct-domain-info') }}
        </a>
        <a
          v-else
          href="#"
          class="dropdown-item"
          data-ba-i="connect-domain"
          @click.prevent="goToDomain()">
          <i class="ct-icon-dns"/>
          {{ $t('ct-domain-connect') }}
        </a>
        <a
          v-if="!isUnpublish"
          href="#"
          class="dropdown-item"
          @click.prevent="goToWebsite(config)">
          <i class="ct-icon-external-link"/>
          {{ $t('ct-go-to-website') }}
        </a>
        <a href="#" class="dropdown-item" @click.prevent="$emit('duplicate')"><i class="ct-icon-duplicate"/>{{ $t('ct-duplicate') }}</a>

        <a href="#" class="dropdown-item" @click.prevent="transfer(true, config)">
          <i class="ct-icon-transfer"/>{{ $t('ct-transfer') }}
        </a>

        <template v-if="(!getUser().is_free) && !isUnpublish">
          <a
            v-if="!config.configuration || !config.configuration.public_link_enable" href="#"
            class="dropdown-item"
            data-ba-i="active-public-link"
            @click.prevent="publicLink(true, config, 'active')">
            <i class="ct-icon-link"/>
            {{ $t('ct-active-public-link') }}
          </a>
          <a
            v-else-if="config.configuration && config.configuration.public_link_enable" href="#"
            class="dropdown-item"
            @click.prevent="publicLink(true, config, 'manage')">
            <i class="svg-icon svgi-link"/>
            {{ $t('ct-manage-public-link') }}
          </a>
        </template>

        <a
          href="#"
          class="dropdown-item"
          data-ba-i="overview-website"
          @click.prevent="goToOverview()">
          <i class="ct-icon-overview"/>
          {{ $t('ct-website-overview') }}
        </a>

        <div class="dropdown-divider"/>
        <a
          href="#"
          class="dropdown-item"
          @click.prevent="confirmDeleteWebsite">
          <i class="ct-icon-trash text-danger"/>
          {{ $t('ct-delete') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {deleteMirror, updateCache as updateCacheMirror} from "../../../../../js/services/editor/mirror";

export default {
  name: "WebsiteActions",
  props: ['website_type', 'config', 'pageHome'],
  computed: {
    isUnpublish() {
      return this.config.status !== 'active';
    },
  },
  methods: {
    ...mapGetters({ getUser: 'user' }),
    goToOverview() {
      this.$router.push({
        name: 'Analytics',
        params: { id: this.config.encrypted_id, type: 'overview' }
      });
    },
    publicLink(show, config, action) {
      this.$store
        .dispatch('dashboard/activeOrManagePublishLink', { show, config, action })
    },

    confirmDeleteWebsite() {
      this.$store
        .dispatch('dashboard/confirmDeleteWebsite', { config: this.config });
    },
    publish(show) {
      this.$emit('publish', show, this.config);
    },
    unpublish(status = 'inactive') {
      this.$emit('unpublish', status);
    },
    openEditSite() {
      let route = { href: ''};

      if(!this.pageHome.is_turbo) {
        route = this.$router.resolve({
          name: 'editor',
          params: {page_id: this.pageHome.encrypted_id}
        });
      } else {
        route = this.$router.resolve({
          name: 'CheetahTurboPageEdit',
          params: { id: this.pageHome.website.encrypted_id, page_id : this.pageHome.encrypted_id }
        });
      }

      window.open(route.href, '_blank');
    },

    goToSettings() {
      if(this.website_type === 'mirror')
        return;

      this.$router.push({
        name: 'GeneralSettings',
        params: { id: this.config.encrypted_id }
      });
    },

    updateCacheMirrorWebsite() {
      updateCacheMirror(this.config.mirror_id)
        .then(res => {
          if(res.data.success){
            this.$snotify.success(
              'Cache Updated'
            );
          }
        });
    },

    deleteMirrorRecord(){
      deleteMirror(this.config.mirror_id)
        .then(res => {
          if(res.data.success){
            this.$snotify.success(
              'Disconected'
            );

          }
        });
    },

    goToWebsite(config) {
      if (config.status !== 'active')
        return;

      window.open('https://' + (config.access_url || config.dominio), '_blank');
    },

    openSite() {
      if(this.website_type === 'mirror')
        this.$router.push({ name: 'Tags' });
      else {
        this.$router.push({
          name: 'SitePages',
          params: { id: this.config.encrypted_id }
        });
      }
    },

    goToDomain() {
      this.$router.push({
        name: 'Domain',
        params: {
          id: this.config.encrypted_id
        }
      });
    },

    transfer(show, config = '') {
      this.$store
        .dispatch('dashboard/transferWebsite', { show, config })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/layout/site/websites/WebsiteActions.vue